import { Component, OnInit } from '@angular/core';
import { DialogParams, IDialogContentComponent } from '../../../../shared/components/modal-dialog/modal-dialog.service';

// Config unique du popup d'information sur le paiement Stripe, partagée par tous les points
// d'ouverture (page facturation + page de début de dépôt) pour éviter toute duplication.
export const SCC_PAYMENT_PROCESS_INFO_DIALOG_PARAMS: DialogParams<undefined> = {
  config: {
    title: 'Comment fonctionne le paiement via Stripe ?',
    width: '640px',
    maxWidth: '90vw',
    height: 'auto',
    showSaveButton: true,
    showCancelButton: false,
    saveButton: {
      label: 'J\'ai compris'
    }
  }
};

@Component({
  selector: 'app-scc-payment-process-info',
  standalone: true,
  imports: [],
  templateUrl: './scc-payment-process-info.component.html',
  styleUrl: './scc-payment-process-info.component.scss'
})
export class SccPaymentProcessInfoComponent implements OnInit, IDialogContentComponent<boolean, undefined> {
  input?: undefined;

  ngOnInit(): void {}

  getResult(): boolean {
    return true;
  }

  isDisabled(): boolean {
    return false;
  }
}
